module.exports = __webpack_public_path__ + "static/media/allFeedsButton.aec21fb8.png";